import { useState } from "react";

import {
  generateXLSXModelForDownload,
  spreadsheetExtensions,
} from "Helpers/File";

import { useFetch } from "Hooks/useFetch";

import Button from "Components/Admin/Buttons";
import ErrorTable from "Components/Admin/ErrorTable";
import FileUploader from "Components/Admin/FileUploader";

import { columns } from "./columns";
import * as S from "./styles";

const CalendarBulk = ({ projectId, setOpenModal, getProjectDates }) => {
  const { fetchData, loading } = useFetch();

  const [files, setFiles] = useState(null);
  const [errors, setErrors] = useState([]);

  const submit = async () => {
    const onSuccessCallback = async () => {
      setOpenModal(false);
      getProjectDates(projectId);
    };

    const onErrorCallback = (invalid_data) => {
      if (!invalid_data) return;
      setErrors(invalid_data);
      setFiles(null);
    };

    const validationCallBack = (data) => {
      let error = "";
      const dataResult = data;

      return {
        data: dataResult,
        error,
      };
    };

    await fetchData({
      method: "post",
      path: {
        validation_path: "/projects/dates/validate",
        creation_path: "/projects/dates/create-bulk",
      },
      body: {
        project_id: projectId,
      },
      successMessage: "Datas criadas com sucesso!",
      onSuccessCallback,
      onErrorCallback,
      validationCallBack,
      config: {
        use_sheet_paginated_fetch: true,
        body_acessor_property: "dates",
        show_success_message: true,
        page_size: 100,
        columns,
        files,
      },
    });
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <S.Section>
          <span>Cadastrar Datas em Massa</span>
          <hr />
        </S.Section>

        <Button
          icon={{
            name: "Upload",
            position: "left",
          }}
          type="button"
          text="Download do modelo"
          disabled={loading}
          outline
          onClick={() =>
            generateXLSXModelForDownload(columns, "Modelo de Criação de Data")
          }
        />

        <FileUploader
          loading={loading}
          allowedExtensions={spreadsheetExtensions}
          setFiles={(f) => {
            setFiles(f);
            setErrors([]);
          }}
          files={files}
          showFileName
        />

        <Button
          type="button"
          text="Criar em massa"
          disabled={loading}
          onClick={submit}
        />
        {errors.length ? (
          <ErrorTable errors={errors} columns={columns} />
        ) : (
          <></>
        )}

        <S.Buttons>
          <Button
            type="button"
            text="Fechar"
            disabled={loading}
            onClick={() => setOpenModal(false)}
            outline
          />
        </S.Buttons>
      </S.Modal>
    </S.Wrapper>
  );
};

export default CalendarBulk;
